'use es6';

import { Map as ImmutableMap } from 'immutable';
import { getDateRangeFilterUseFiscalYear, getUseFiscalYearInAggregation, getDateRangeFilterValue, getReportConfig } from 'reporting-data/report/configReportGetters';
import DateRangeEditor from 'reporting-enablement/components/reportEditors/DateRangeEditor';
import ErrorBoundary from '../ErrorBoundary';
import { capture } from '../../sentry/sales-analytics-sentry';
import { DATERANGE_INPUT_ERROR_BOUNDARY } from '../../sentry/sentry-events';
import { Metrics } from '../../monitoring/Metrics';
import { isSnowflakeReport } from '../../utils/salesAnalyticsHelpers';
import usageTracker from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const DateRangeControlComponent = ({
  updateContext,
  report
}) => /*#__PURE__*/_jsx(DateRangeEditor, {
  appUsageTracker: usageTracker,
  options: {},
  onChange: updatedReport => {
    const reportConfig = getReportConfig(updatedReport);
    const dateRange = getDateRangeFilterValue(reportConfig).toJS();
    const useFiscalYear = getDateRangeFilterUseFiscalYear(reportConfig);
    const useFiscalYearInAggregation = getUseFiscalYearInAggregation(reportConfig);
    updateContext({
      dateRange: ImmutableMap(Object.assign({}, dateRange, {
        useFiscalYear,
        useFiscalYearInAggregation
      }))
    }, report);
  },
  report: report
});
export const DateRangeControl = props => {
  const handleError = error => {
    capture(DATERANGE_INPUT_ERROR_BOUNDARY, {
      error,
      extra: Object.assign({}, props)
    });
    Metrics.counter('daterange-input-error-boundary', {
      sub_app_key: props.subAppKey
    }).increment();
  };
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    onError: handleError,
    children: /*#__PURE__*/_jsx(DateRangeControlComponent, Object.assign({}, props))
  });
};
DateRangeControl.displayName = 'DateRangeControl';
DateRangeControl.isUsableForReport = ({
  report
}) => !isSnowflakeReport(report);